import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'
import dayjs, { type Dayjs } from 'dayjs'
import minBy from 'lodash/minBy'

export const getFirstFreeDayOfMonth = (slots: Pick<FreeSlot, 'startDate'>[], month: Dayjs) => {
  const firstFreeSlot = minBy(
    slots.filter(({ startDate }) => dayjs(startDate).isSame(month, 'month')),
    ({ startDate }) => dayjs(startDate).valueOf(),
  )

  return firstFreeSlot ? dayjs(firstFreeSlot.startDate) : null
}
